import * as React from "react";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
// import { Typography } from "@mui/material";
import Typography from "@mui/material/Typography";
// import { createTheme, ThemeProvider } from "@mui/material/styles";
import createTheme from "@mui/material/styles/createTheme";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import BookingApi from "../../../API/Apis/BookingApi";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { t } from "i18next";
import { AppStandardButton } from "../../UI/AppButtons";
import { formatTheme } from "../../../config/MuiColorThemes";
import BookingGetters from "../../../store/onlineBooking/getters";
import owasp from "owasp-password-strength-test";

export default function SignUp() {
  const navigate = useNavigate();
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }
  const isSmallScreen = window.innerWidth <= 768;

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: 850,
        },
      },
      targetOrigin
    );
  }
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [isCallFromBooking] = useState(
    (searchParams.has("isCallFromBooking") &&
      searchParams.get("isCallFromBooking") == "true") ||
      (searchParams.has("callFrom") &&
        searchParams.get("callFrom") == "booking")
  );
  useEffect(() => {
    requestParentResize();
  }, []);
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  owasp.config({
    allowPassphrases: false,
    minLength: 8,
    minOptionalTestsToPass: 4,
  });

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().required("Email is required").email("Email is invalid"),
    phoneNumber: Yup.string().required("Phone Number is required"),

    password: Yup.string()
      .required("Password is required")
      .test("is-strong-password", function (value) {
        if (!value) return false;
        const result = owasp.test(value);
        if (!result.strong) {
          return this.createError({
            message: result.errors.join(" "),
          });
        }
        return true;
      }),

    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Confirm Password does not match"),
    birthDate: Yup.string().nullable(),
    acceptTerms: Yup.boolean().oneOf(
      [true],
      "You must accept the Terms and Conditions"
    ),
  });

  useEffect(() => {
    document.body.style.overflowX = "hidden";

    return () => {
      document.body.style.overflowX = "";
    };
  }, []);

  const handleSignInNavigation = () => {
    const prevPageUrl = location.state?.from;
    const params = new URLSearchParams({ callSignIn: "callSignIn" }).toString();
    if (prevPageUrl) {
      const url = new URL(prevPageUrl, window.location.origin);
      navigate(url.pathname + (url.search ? url.search + "&" : "?") + params);
    } else {
      navigate("/");
    }
  };
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const showNewIFrame = (iframeFor) => {
    window.parent.postMessage(
      {
        event_id: iframeFor,
      },
      targetOrigin
    );
  };
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 18);
  const bookingInformation = BookingGetters.getBookingDetails();
  const dealerId = bookingInformation?.pickUpLocationDetails?.dealerId;
  const onSubmit = (data) => {
    BookingApi.createNewUser(data, dealerId).then((data) => {
      if (data.data.status == "success") {
        localStorage.setItem("userID", data.data.id);
        localStorage.setItem("onlineuserFName", data.data.firstName);
        localStorage.setItem("onlineuserLName", data.data.lastName);
        localStorage.setItem("onlineuserEmailId", data.data.emailId);
        localStorage.setItem("idSupplier", data.data.supplierId);
        localStorage.setItem("mobileNumber", data.data.mobileNumber);
        localStorage.setItem("isUserLoggedin", "true");
        if (isCallFromBooking) {
          navigate(`/anagraphData?isCallFromBooking=${isCallFromBooking}`, {
            state: { from: window.location.href },
          });
        } else {
          navigate("/", { state: { from: window.location.href } });
          showNewIFrame("showIFrameForBooking");
        }
      } else {
        setOpenModal(true);
        if (data.data.message == "Email already exist") {
          setModalMessage(t("Account already registered with this email id"));
          reset({
            email: "",
            phoneNumber: "",
          });
        } else if (data.data.message == "Mobile number already exist") {
          setModalMessage(
            t("Account already registered with this mobile number")
          );
          reset({
            phoneNumber: "",
          });
        }
      }
    });
  };
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const requestOnClose = () => {
    setOpenModal(false);
    setModalMessage("");
  };

  const [isDesktop] = useState(window.innerWidth >= 1310);
  return (
    <ThemeProvider theme={dynamicTheme}>
      <div className="min-h-screen w-full flex justify-center items-center bg-white">
        <div className="w-full" style={{ maxWidth: "1462px" }}>
          <div
            className="grid grid-cols-1 md:grid-cols-2"
            style={isDesktop ? { margin: "" } : {}}
          >
            <div style={isDesktop ? { width: "100%" } : {}}>
              <img
                src="/assets/images/SiteLogo.jpg"
                alt={"logo"}
                style={
                  isDesktop
                    ? {
                        height: "134px",
                        width: "231.03px",
                        marginTop: "136px",
                        marginLeft: "19px",
                      }
                    : { marginLeft: "-14%", width: "50%", marginTop: "66px" }
                }
              />
              <div
                style={{
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  color: "#1E1E1E",
                  fontSize: "36px",
                  marginTop: isDesktop ? "23px" : "0px",
                  marginLeft: isDesktop ? "112px" : "20px",
                }}
              >
                {t("Registration")}
              </div>
              <div
                style={{
                  fontFamily: "MBCorpoSText-Regular-Web-new",
                  color: "#1E1E1E",
                  fontSize: "24px",
                  marginTop: isDesktop ? "14px" : "0px",
                  marginLeft: isDesktop ? "112px" : "20px",
                  width: isDesktop ? "358px" : "",
                  height: "110px",
                }}
              >
                {t(
                  "Create your account to make and manage bookings and access rental history."
                )}
              </div>
            </div>
            <div
              className="flex flex-col items-center w-full md:0"
              style={{
                backgroundColor: "#000000",
                width: isDesktop ? "100%" : "",
                marginTop: isDesktop ? "-3%" : "0%",
                marginLeft: isDesktop ? "4%" : "0%",
              }}
            >
              <div className="w-[100%]">
                <Container component="main" maxWidth="xs">
                  <Box
                    sx={{
                      marginTop: 5,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      boxShadow: "none",
                    }}
                    className={` ${
                      isSmallScreen ? "box-border justify-center flex px-4" : ""
                    }`}
                  >
                    <Box
                      component="form"
                      onSubmit={handleSubmit(onSubmit)}
                      noValidate
                      sx={{
                        "& .MuiTextField-root": { mt: 2, width: "40ch" },
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <h1
                            className="text-3xl"
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                              marginTop: isDesktop ? "60px" : "50px",
                              marginLeft: isDesktop ? "0px" : "3px",
                              marginBottom: isDesktop ? "27px" : "15px",
                              fontSize: "36px",
                            }}
                          >
                            {t("Registration")}
                          </h1>
                        </Grid>
                        <Grid item xs={12}>
                          <label
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                              display: "block",
                              width: "100%",
                            }}
                          >
                            {t("First Name")}
                          </label>
                          <TextField
                            required
                            style={{
                              width: isDesktop ? "418px" : "360px",
                              marginLeft: isDesktop ? "0" : "1%",
                              backgroundColor: "#D9D9D9",
                              color: "black",
                              marginTop: "4px",
                              marginBottom: "10px",
                              borderRadius: "8px",
                            }}
                            InputProps={{
                              className: "MBCorpoSText-Regular-Web-new",
                              sx: {
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                                height: "38px",
                                padding: 0,
                              },
                            }}
                            InputLabelProps={{
                              className: "MBCorpoAScreen1Cond-Regular-Web",
                              sx: {
                                "&.MuiInputLabel-root": {
                                  fontFamily: "MBCorpoSText-Regular-Web-new",
                                  marginTop: "-6px",
                                  fontSize: "12px",
                                },
                                "&.MuiInputLabel-shrink": {
                                  display: "none",
                                },
                              },
                            }}
                            fullWidth
                            id="firstName"
                            label={t("First Name")}
                            autoFocus
                            {...register("firstName")}
                            error={!!errors.firstName}
                            helperText={errors.firstName?.message}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <label
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                            }}
                          >
                            {t("Last Name")}
                          </label>
                          <TextField
                            required
                            style={{
                              width: isDesktop ? "418px" : "360px",
                              marginLeft: isDesktop ? "0" : "1%",
                              backgroundColor: "#D9D9D9",
                              color: "black",
                              marginTop: "4px",
                              marginBottom: "10px",
                              borderRadius: "8px",
                            }}
                            InputProps={{
                              className: "MBCorpoSText-Regular-Web-new",
                              sx: {
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                                height: "38px",
                              },
                            }}
                            InputLabelProps={{
                              className: "MBCorpoAScreen1Cond-Regular-Web",
                              sx: {
                                "&.MuiInputLabel-root": {
                                  fontFamily: "MBCorpoSText-Regular-Web-new",
                                  marginTop: "-6px",
                                  fontSize: "12px",
                                },
                                "&.MuiInputLabel-shrink": {
                                  display: "none",
                                },
                              },
                            }}
                            fullWidth
                            id="lastName"
                            label={t("Last Name")}
                            {...register("lastName")}
                            error={!!errors.lastName}
                            helperText={errors.lastName?.message}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <label
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                            }}
                          >
                            {t("Email Address")}
                          </label>
                          <TextField
                            required
                            fullWidth
                            style={{
                              width: isDesktop ? "418px" : "360px",
                              marginLeft: isDesktop ? "0" : "1%",
                              backgroundColor: "#D9D9D9",
                              color: "black",
                              marginTop: "4px",
                              marginBottom: "10px",
                              borderRadius: "8px",
                            }}
                            InputProps={{
                              className: "MBCorpoSText-Regular-Web-new",
                              sx: {
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                                height: "38px",
                              },
                            }}
                            InputLabelProps={{
                              className: "MBCorpoAScreen1Cond-Regular-Web",
                              sx: {
                                "&.MuiInputLabel-root": {
                                  fontFamily: "MBCorpoSText-Regular-Web-new",
                                  marginTop: "-6px",
                                  fontSize: "12px",
                                },
                                "&.MuiInputLabel-shrink": {
                                  display: "none",
                                },
                              },
                            }}
                            id="email"
                            label={t("Email Address")}
                            {...register("email")}
                            error={!!errors.email}
                            helperText={errors.email?.message}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <label
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                            }}
                          >
                            {t("Phone Number")}
                          </label>
                          <TextField
                            required
                            fullWidth
                            style={{
                              width: isDesktop ? "418px" : "360px",
                              marginLeft: isDesktop ? "0" : "1%",
                              backgroundColor: "#D9D9D9",
                              color: "black",
                              marginTop: "4px",
                              marginBottom: "10px",
                              borderRadius: "8px",
                            }}
                            InputProps={{
                              className: "MBCorpoSText-Regular-Web-new",
                              sx: {
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                                height: "38px",
                              },
                            }}
                            InputLabelProps={{
                              className: "MBCorpoAScreen1Cond-Regular-Web",
                              sx: {
                                "&.MuiInputLabel-root": {
                                  fontFamily: "MBCorpoSText-Regular-Web-new",
                                  marginTop: "-6px",
                                  fontSize: "12px",
                                },
                                "&.MuiInputLabel-shrink": {
                                  display: "none",
                                },
                              },
                            }}
                            id="phoneNumber"
                            type="tel"
                            label={t("Phone Number")}
                            {...register("phoneNumber", {
                              pattern: {
                                value: /^[+\d]+$/,
                                message: "Only numbers and + are allowed",
                              },
                            })}
                            error={!!errors.phoneNumber}
                            helperText={errors.phoneNumber?.message}
                            inputProps={{
                              pattern: "^[+0-9]+$",
                              maxLength: 15,
                            }}
                            onInput={(e) => {
                              const target = e.target as HTMLInputElement;
                              target.value = target.value.replace(
                                /[^0-9+]/g,
                                ""
                              );
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <label
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                            }}
                          >
                            {t("Password")}
                          </label>
                          <TextField
                            required
                            fullWidth
                            style={{
                              width: isDesktop ? "418px" : "360px",
                              marginLeft: isDesktop ? "0" : "1%",
                              backgroundColor: "#D9D9D9",
                              color: "black",
                              marginTop: "4px",
                              marginBottom: "10px",
                              borderRadius: "8px",
                            }}
                            InputProps={{
                              className: "MBCorpoSText-Regular-Web-new",
                              sx: {
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                                height: "38px",
                              },
                            }}
                            InputLabelProps={{
                              className: "MBCorpoAScreen1Cond-Regular-Web",
                              sx: {
                                "&.MuiInputLabel-root": {
                                  fontFamily: "MBCorpoSText-Regular-Web-new",
                                  marginTop: "-6px",
                                  fontSize: "12px",
                                },
                                "&.MuiInputLabel-shrink": {
                                  display: "none",
                                },
                              },
                            }}
                            label={t("Password")}
                            type="password"
                            id="password"
                            {...register("password")}
                            error={!!errors.password}
                            helperText={errors.password?.message}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <label
                            style={{
                              color: "#FFFFFF",
                              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                            }}
                          >
                            {t("Confirm Password")}
                          </label>
                          <TextField
                            required
                            fullWidth
                            style={{
                              width: isDesktop ? "418px" : "360px",
                              marginLeft: isDesktop ? "0" : "1%",
                              backgroundColor: "#D9D9D9",
                              color: "black",
                              marginTop: "4px",
                              marginBottom: "10px",
                              borderRadius: "8px",
                            }}
                            InputProps={{
                              className: "MBCorpoSText-Regular-Web-new",
                              sx: {
                                fontFamily: "MBCorpoSText-Regular-Web-new",
                                height: "38px",
                              },
                            }}
                            InputLabelProps={{
                              className: "MBCorpoAScreen1Cond-Regular-Web",
                              sx: {
                                "&.MuiInputLabel-root": {
                                  fontFamily: "MBCorpoSText-Regular-Web-new",
                                  marginTop: "-6px",
                                  fontSize: "12px",
                                },
                                "&.MuiInputLabel-shrink": {
                                  display: "none",
                                },
                              },
                            }}
                            label={t("Confirm Password")}
                            type="password"
                            id="confirmPassword"
                            {...register("confirmPassword")}
                            error={!!errors.confirmPassword}
                            helperText={errors.confirmPassword?.message}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormControlLabel
                            className="select-none"
                            control={
                              <Checkbox
                                color="primary"
                                className="ml-5"
                                {...register("acceptTerms")}
                                sx={{
                                  "& .MuiCheckbox-root": {
                                    padding: 0,
                                  },
                                  "& .MuiSvgIcon-root": {
                                    backgroundColor: "#000000",
                                    color: "#FFFFFF",
                                    borderRadius: "4px",
                                  },
                                }}
                              />
                            }
                            label={
                              <Box
                                component="div"
                                fontSize={15}
                                color="#FFFFFF"
                                className=""
                              >
                                <span
                                  style={{
                                    fontFamily:
                                      "MBCorpoAScreen1Cond-Regular-Web",
                                  }}
                                >
                                  {t("Please accept Terms and condition")}
                                </span>
                              </Box>
                            }
                          />
                          {/* Display error if checkbox is not checked */}
                          {errors.acceptTerms && (
                            <Typography variant="body2" color="error">
                              {errors.acceptTerms.message}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        size="large"
                        sx={{
                          mt: 3,
                          py: 1.5,
                          bgcolor: `${dynamicTheme?.palette.primary.main} !important`,
                          color: `${dynamicTheme?.palette?.["secondaryColor"].contrastText} !important`,
                          fontWeight: "bold",
                          textTransform: "capitalize",
                          fontFamily: "MBCorpoSText-Regular-Web-new",
                          marginBottom: "4%",
                          height: "38px",
                          fontSize: "16px",
                        }}
                      >
                        {t("Create Account")}
                      </Button>
                      <div
                        className={` ${
                          isSmallScreen
                            ? "grow flex flex-col items-center gap-4 box-border"
                            : ""
                        } `}
                        style={{ marginBottom: "14px" }}
                      >
                        <span
                          className="text-[#FFFFFF]"
                          style={{
                            fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                            cursor: "pointer",
                          }}
                          onClick={handleSignInNavigation}
                        >
                          {t("Already have an account?")}{" "}
                          <span style={{ color: "#49bdfb" }}>
                            {" "}
                            {t("Sign in")}
                          </span>
                        </span>
                      </div>
                    </Box>
                  </Box>
                </Container>
              </div>
            </div>
            <Dialog
              open={openModal}
              onClose={requestOnClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              PaperProps={{
                style: {
                  borderRadius: "10px",
                  minWidth: "370px",
                  position: "absolute",
                  top: isDesktop ? "50%" : "50%",
                  left: isDesktop ? "50%" : "40%",
                  transform: "translate(-50%, -50%)",
                },
              }}
            >
              <DialogTitle
                style={{
                  padding: "1rem",
                  fontFamily: "MBCorpoSText-Regular-Web-new",
                }}
              >
                {modalMessage}
              </DialogTitle>
              <DialogActions
                sx={{
                  justifyContent: "center",
                }}
              >
                <AppStandardButton variant="outlined" onClick={requestOnClose}>
                  <p className="text-black normal-case">{t("Close")}</p>
                </AppStandardButton>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
